import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";

import { ThemeContext } from "../../../../context/ThemeContext";

import pdfIcon from "../../../../icons/myIcons/pdficon.png";
import {
  Badge,
  Button,
  Card,
  Col,
  Dropdown,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uploadInvoicesApi } from "../../../../service/bankApi/uploadInvoice";
import { getInvoicesFileList } from "../../../../service/bankApi/getInvoicesFilesList";
import { toast, ToastContainer } from "react-toastify";
import AutohideToaster from "../../Toaster/Toaster";

const BulkUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {propertyId} = useSelector(state =>state.auth)
  const notifyTopRight = () => {
    toast.success("✔️ Submit Successfully !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
//  const  notifyTopRightError = () => {
//   toast.error("Please select valid files (JPG, PNG, PDF only) !!!", {
//     position: "top-right",
//     autoClose: 5000,
//     hideProgressBar: false,
//     closeOnClick: false,
//     pauseOnHover: true,
//     draggable: true,
//   });
//   }

const notifyTopRightError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });
};

  const [showSuccess, setShowSuccess] = useState(false);
 const [toasterValue,setToasterValue] = useState(false)
 const[error,setError] = useState(false)
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const { changeBackground } = useContext(ThemeContext);
  const fileInputRef = useRef(null);
  const [filesArr, setFilesArr] = useState([]);
  const[isLoading,setIsLoading] = useState(false)

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);

  const handleAddInvoice = () => {
    fileInputRef.current.click();
  };

  // const handleFileInputChange = (event) => {
   
  //   const selectedFiles = Array.from(event.target.files);
  //   const validTypes = ['image/jpeg', 'image/png', 'application/pdf'];

  //   const invalidFiles = selectedFiles.filter(
  //     (file) => !validTypes.includes(file.type)
  //   );

  //   if (invalidFiles.length > 0) {
  //     notifyTopRightError()
  //     setFilesArr([]);
  //   } else {
  //     setError('');
  //     setFilesArr(selectedFiles);
  //     console.log(selectedFiles);
  //   }
  //   // console.log(files);
  //   // setFilesArr(files);
  // };

  const handleFileInputChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const validTypes = ['application/pdf'];
    const maxSize = 6 * 1024 * 1024; // 6 MB in bytes
  
    // Filter valid and invalid files based on type and size
    const validFiles = selectedFiles.filter(
      (file) => validTypes.includes(file.type) && file.size <= maxSize
    );
    const invalidFiles = selectedFiles.filter(
      (file) => !validTypes.includes(file.type) || file.size > maxSize
    );
  
    // Handle invalid files
    if (invalidFiles.length > 0) {
      invalidFiles.forEach((file) => {
        if (!validTypes.includes(file.type)) {
          notifyTopRightError('Please select valid files (PDF only)');
        } else if (file.size > maxSize) {
          // Check if the file size exceeds the max size of 6 MB
          notifyTopRightError('File size exceeds 6 MB');
        }
      });
  
      // Append only the valid files to the existing list of files
      setFilesArr((prevFiles) => [...prevFiles, ...validFiles]);
    } else {
      setError('');
      setFilesArr(selectedFiles); // If all files are valid, just set them
    }
  };
  
  const handleDrop = (event) => {
    event.preventDefault();
    const selectedFiles = Array.from(event.dataTransfer.files);
    const validTypes = ['application/pdf'];
    const maxSize = 6 * 1024 * 1024; // 6 MB in bytes
  
    // Filter valid and invalid files based on type and size
    const validFiles = selectedFiles.filter(
      (file) => validTypes.includes(file.type) && file.size <= maxSize
    );
    const invalidFiles = selectedFiles.filter(
      (file) => !validTypes.includes(file.type) || file.size > maxSize
    );
  
    // Handle invalid files
    if (invalidFiles.length > 0) {
      invalidFiles.forEach((file) => {
        if (!validTypes.includes(file.type)) {
          notifyTopRightError('Please select valid files (PDF only)');
        } else if (file.size > maxSize) {
          // Check if the file size exceeds the max size of 6 MB
          notifyTopRightError('File size exceeds 6 MB');
        }
      });
  
      // Append only the valid files to the existing list of files
      setFilesArr((prevFiles) => [...prevFiles, ...validFiles]);
    } else {
      setError('');
      setFilesArr(selectedFiles); // If all are valid, just set them
    }
  };
  


  const handleDragOver = (event) => {
    event.preventDefault();
  };
  // const handleDrop = (event) => {
  //   event.preventDefault();
  //   const selectedFiles = Array.from(event.dataTransfer.files);
  //   const validTypes = ['image/jpeg', 'image/png', 'application/pdf'];

  //   const invalidFiles = selectedFiles.filter(
  //     (file) => !validTypes.includes(file.type)
  //   );

  //   if (invalidFiles.length > 0) {
  //     notifyTopRightError()
  //     setFilesArr([]);
  //   } else {
  //     setError('');
  //     setFilesArr(selectedFiles);
  //     console.log(selectedFiles);
  //   }
  // };
  function handleRemoveFileFromArray(index) {
    setFilesArr(filesArr.filter((_, i) => i !== index));
  }
  const convertBytesToKB = (sizeInBytes) => {
    return (sizeInBytes / 1024).toFixed(2);
  };

  function uploadInvoices() {
    setIsLoading(true);
    const files = new FormData();

    filesArr.map((item, index) => files.append("files", item, item.name));

    var data = {
      propertyId : propertyId || 0
    }

    dispatch(
      uploadInvoicesApi(
        files,data,
        (res) => {

          notifyTopRight()
          setFilesArr([])
          setIsLoading(false);
        },
        (err) => {
          console.log(err);
          setIsLoading(false);
        }
      )
    );
  }

  return (
    <>
    <ToastContainer />

      <div
        className="card card-wiget"
        style={{ width: "100%", cursor: "pointer",height:'100%' }}
        onClick={handleAddInvoice}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <div className="card-body d-flex align-items-center justify-content-center">
          <div className="card-wiget-info d-flex justify-content-center flex-column align-items-center">
            <h4 className="count-num" style={{color:'rgba(23, 90, 169, 0.78)'}}>Upload Invoices</h4>
            <img className="mt-2 mb-2" src={pdfIcon} style={{ width: "22%" }} />
            <p>Total Selected : {filesArr.length}</p>
            <input
              type="file"
              multiple
              style={{ display: "none" }}
              ref={fileInputRef}
              accept=".pdf,.png,.jpg"
              onChange={handleFileInputChange}
            />
            <p className="fs-5">
              You can drag and drop or upload multiple files here{" "}
            </p>
          </div>
        </div>
        {/* <div className="back-icon">
							<svg width="64" height="127" viewBox="0 0 64 127" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g opacity="0.05">
								<path d="M70.1991 32.0409C63.3711 28.2675 56.1119 25.3926 48.9246 22.4098C44.7559 20.6849 40.7669 18.6724 37.2451 15.8694C30.3093 10.3351 31.639 1.3509 39.7607 -2.20684C42.0606 -3.21307 44.4684 -3.5365 46.9121 -3.68024C56.3275 -4.18336 65.2758 -2.4584 73.7928 1.63839C78.0333 3.68679 79.4349 3.03993 80.8723 -1.38029C82.3817 -6.05207 83.6395 -10.7957 85.041 -15.5034C85.9753 -18.6659 84.8254 -20.7502 81.8426 -22.0799C76.3802 -24.4876 70.7741 -26.2126 64.8805 -27.1469C57.19 -28.3329 57.19 -28.3688 57.1541 -36.0952C57.1181 -46.984 57.1181 -46.984 46.1934 -46.984C44.6122 -46.984 43.0309 -47.02 41.4497 -46.984C36.3467 -46.8403 35.4842 -45.9419 35.3405 -40.8029C35.2686 -38.503 35.3405 -36.203 35.3045 -33.8671C35.2686 -27.0391 35.2327 -27.1469 28.6922 -24.7751C12.88 -19.0252 3.1052 -8.24421 2.06304 9.00543C1.12868 24.2785 9.10664 34.5924 21.6486 42.1032C29.375 46.739 37.9279 49.4702 46.1215 53.0998C49.3199 54.5014 52.3745 56.1185 55.0338 58.3466C62.904 64.8512 61.4665 75.6681 52.1229 79.7649C47.1277 81.957 41.845 82.4961 36.4186 81.8133C28.0453 80.7711 20.0314 78.579 12.4847 74.6619C8.06447 72.3619 6.77075 72.9729 5.2614 77.7524C3.96768 81.8852 2.81771 86.0538 1.66773 90.2225C0.122451 95.8286 0.697435 97.1583 6.05201 99.7817C12.88 103.088 20.1752 104.777 27.6141 105.963C33.4358 106.897 33.6155 107.149 33.6874 113.186C33.7233 115.917 33.7233 118.684 33.7593 121.416C33.7952 124.866 35.4483 126.878 39.006 126.95C43.0309 127.022 47.0918 127.022 51.1167 126.914C54.4229 126.842 56.1119 125.045 56.1119 121.703C56.1119 117.966 56.2916 114.192 56.1478 110.455C55.9682 106.646 57.6213 104.705 61.2868 103.699C69.7319 101.399 76.9193 96.8708 82.4535 90.1147C97.8345 71.4276 91.9768 44.0797 70.1991 32.0409Z" fill="#9568FF"/>
								</g>
							</svg>
						</div> */}
      </div>

      <Col lg={12}>
        <Card>
          <Card.Header>
            <Card.Title>Bulk Upload Preview</Card.Title>
            {filesArr.length == 0 && (
              <p style={{ color: "red" }}>Please select files *</p>
            )}
                        {filesArr.length > 0 && (
              <button
                className="btn btn-success dz-xs-flex m-r5"
                style={{background:'rgba(233, 133, 35, 0.84)',border:'none'}}
                onClick={() => {
                  uploadInvoices();
                }}
              >
              { isLoading ? "Uploading..." :" Submit "}
              </button>
            )}
          </Card.Header>
          <Card.Body>
            <Table responsive>
              <thead style={{color:'rgba(23, 90, 169, 0.78)'}}>
                <tr>
                  <th className="width80">
                    <strong>#</strong>
                  </th>
                  <th>
                    <strong>File Name </strong>
                  </th>
                  <th>
                    <strong>File Type</strong>
                  </th>
                  <th>
                    <strong>Size</strong>
                  </th>
                  {/* <th>
                    <strong>Size</strong>
                  </th> */}
                 

                  <th>Action</th>
                </tr>
              </thead>
              <tbody  style={{color:'black'}}>
                {filesArr.map((item, index) => (
                  <tr>
                    <td>
                      <strong>{index + 1}</strong>
                    </td>
                    <td>{item.name}</td>
                    <td>{item?.type?.split("/")[1]}</td>

                    <td>{convertBytesToKB(item.size) +" " +"Kb"}</td>
                 

                  
                   
                    <td > 
                

                    <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip">{"delete from list"}</Tooltip>}
                        >
                          <i
                            className="material-icons"
                            style={{
                              color: "red",
                              marginRight: "6px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleRemoveFileFromArray(index);
                            }}
                          >
                            delete
                          </i>
                        </OverlayTrigger>
                      {/* <Dropdown>
                        <Dropdown.Toggle
                          variant="success"
                          className="light sharp i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              handleRemoveFileFromArray(index);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>

      <Modal className="fade" show={showSuccess} centered>
        <Modal.Header>
          <Modal.Title>Success</Modal.Title>
          <Button
            onClick={() => setShowSuccess(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p>Files Uploaded Successfully</p>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default BulkUpload;
